<template>
<div class="footerbox">
    <div class="m">
        <div class="top">
            <div class="erweima">
                <div class="wechat">
                    <img src="@/assets/images/ewm_03.png" alt="">
                    <p>微信小程序</p>
                </div>
                <div class="alipay">
                    <img src="@/assets/images/ewm_04.png" alt="">
                    <p>支付宝小程序</p>
                </div>
            </div>
            <div class="info">
                <!-- <p>电话：400-68-12122</p> -->
                <p>地址：河南省郑州市中原区西三环大学科技园（东区）10号楼16楼</p>
                <!-- 跨度 -->
                <!-- <p>©版权所有 郑州跨度信息技术有限公司  <a href="https://beian.miit.gov.cn" target="_blank">豫ICP备18016108号-1</a></p> -->
                <!-- 智慧路网 -->
                 <p>©版权所有 河南智慧路网高速公路有限公司  <a href="https://beian.miit.gov.cn" target="_blank">豫ICP备2020025823号-1</a></p>
            </div>
            <div class="phone">
                <!-- <div class="img">
                    <img src="@/assets/images/rexian2.png" alt="">
                </div> -->
                <!-- <p>400-68-12122</p> -->
            </div>
        </div>
        <div class="link">
            <a @click.prevent="Tocontone">首页</a>
            <span>|</span> 
            <!-- <router-link to="/onLine" tag='a'>网上商城</router-link>  -->
            <a @click.prevent="Toconttwo">ETC营业厅</a>
            <!-- <span>|</span>  -->
               <!-- <a class='link'
              target="_blank"
             href="https://shop93137571.m.youzan.com/v2/feature/mymxER4Oo3?ps=760">车品商城</a> -->
            <span>|</span> 
            <!-- <router-link to="/productDescription" tag='a'>产品介绍</router-link>  -->
            <a @click.prevent="Tocontthree">平台优势</a>
            <span>|</span> 
            <!-- <router-link to="/commonQuestion" tag='a'>常见问题</router-link>  -->
            <a @click.prevent="Tocontfour">常见问题</a>
            <span>|</span> 
            <!-- <router-link to="/aboutUs" tag='a'>关于我们</router-link> -->
            <a>关于我们</a>
        </div>
    </div>
</div>
</template>
<script>
import { scrollAnimation } from '../../../static/utils.js';
export default {
    data() {
        return {
            currentPath: '/index'
        }
    },
    watch: {
        $route(to,from) {
            this.currentPath = to.path;
        }
    },
    methods:{
        Tocontone(){
            if(this.currentPath === '/index') {
                // const div = document.getElementById('index');
                // const height = div.offsetTop - 80;
                     const height=localStorage.getItem('indexHeight');
                // window.scrollTo(height);
                scrollAnimation(height)
                // document.querySelector("#index").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            } else {
                this.$router.push({name: 'Home'})
            }
        },
        Toconttwo(){
            if(this.currentPath === '/index') {
                // const div = document.getElementById('online');
                // const height = div.offsetTop - 80;
                     const height=localStorage.getItem('lineHeight');
                // window.scroll(0,height);
                scrollAnimation(height)
                // document.querySelector("#online").scrollIntoView(true);
                // document.querySelector("#online").scrollIntoView({behavior: "smooth", block: "start", });
            } else {
                // this.$router.push({name: 'OnLineHandle'})
                this.$router.push({name: 'Home'});
                // document.querySelector("#online").scrollIntoView({behavior: "smooth", block: "start", });
            }
        },
        Tocontthree(){
            if(this.currentPath === '/index') {
                // const div = document.getElementById('chanpin');
                // const height = div.offsetTop - 80;
                     const height=localStorage.getItem('chanpinHeight');
                // window.scrollTo(0,height);
                scrollAnimation(height)
                // document.querySelector("#chanpin").scrollIntoView(true);
                // document.querySelector("#chanpin").scrollIntoView({behavior: "smooth", block: "start", });
            } else {
                this.$router.push({name: 'ProductDes'})
                // this.$router.push({name: 'Home'});
            }
        },
        Tocontfour(){
            if(this.currentPath === '/index') {
                // const div = document.getElementById('wenti');
                // const height = div.offsetTop - 80;
                const height=localStorage.getItem('wentiHeight');
                // console.log(height)
                // window.scrollTo(0,height);
                scrollAnimation(height)
                // document.querySelector("#wenti").scrollIntoView(true);
                // document.querySelector("#wenti").scrollIntoView({behavior: "smooth", block: "start", });
            } else {
                this.$router.push({name: 'QuestionDetailInfo'})
            }
        },
        Tocontfive(){
            if(this.currentPath === '/index') {
                // const div = document.getElementById('guanyu');
                // const height = div.offsetTop - 120;
                const height=localStorage.getItem('guanyuHeight');
                // console.log(height)
                // window.scrollTo(0,height);
                scrollAnimation(height)
                // document.querySelector("#guanyu").scrollIntoView(true);
                // document.querySelector("#guanyu").scrollIntoView({behavior: "smooth", block: "start", });
            } else {
                this.$router.push({name: 'AboutUs'})
            }
        }
    },
    mounted() {
        $('.link a').click(function(){
            var index = ($(this).index()+1 +1)/2;
            // var index = $(this).index()+1
            // console.log(index)
			$('.nav a:nth-child('+index+')').addClass('visited').siblings().removeClass('visited');
		})
    },
}
</script>
<style lang="scss" scoped>
    @import './css/index.scss';
</style>





// WEBPACK FOOTER //
// src/components/footer/index.vue